import { TabContainer } from "./Tab1";

const Tab4 = () => {
  return (
    <TabContainer>
      <p className="bold">充消返利</p>
      <p> <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）</p>
      <p> <span className="bold">活动时间</span>：3月15日开服后-5月15日24：00</p>
      <p><span className="bold">活动NPC</span>：江湖接引使</p>
      <p><span className="bold">活动内容</span>：</p>
      <p>
        （1）新服专属充值回馈开启！活动期间大侠充值额达到15元、68元、168元、588元时，可于江湖接引使处分别额外领取2E、3E、5E、10E经验（
        <span>共计最多可领20亿经验</span>），助力大侠迅速提升等级。
      </p>
      <p>
        （2）新服专属砸蛋回馈开启。3月15日-4月19日，大侠消灭恶狼左使数达到5、10、50、100、200、400时，可以于江湖接引使处分别领取200W、200W、1600W、2000W、4000W、8000W剑侠币悬赏回馈
        <span>共计1.6E剑侠币</span>）。
      </p>
      <p>
        （3）消灭恶狼左使数量达到400个时，还可获得一个额外称号-和平使者
        <span>（生命值+480，攻击技能加成+30%）</span>。
      </p>
      <p>
        （4）新服专属礼包持续上架。新服上架全新<span>新手强化礼包、剑侠启程礼包、每日霹雳弹礼包、特惠金票</span>等超值福利特惠礼包，买到即赚。
      </p>
    </TabContainer>
  );
};

export default Tab4;
